import React from "react";
import { Radio, RadioProps, SxProps } from "@mui/material";
import styled from "styled-components";
import { RadioOnIcon } from "../Icon/RadioOnIcon";
import { RadioOffIcon } from "../Icon/RadioOffIcon";
import { CheckedIcon } from "../Icon/CheckedIcon";
import { UncheckedIcon } from "../Icon/UncheckedIcon";

interface IStyledRadio extends RadioProps {
    type?: "checkbox" | "radio";
    sx?: SxProps;
}

export const UIRadioButton = (props: IStyledRadio) => {
    return (
        <CustomRadio
            {...props}
            checkedIcon={!props.type || props.type === "radio" ? <RadioOnIcon /> : <CheckedIcon />}
            icon={!props.type || props.type === "radio" ? <RadioOffIcon /> : <UncheckedIcon />}
        />
    );
};

const CustomRadio = styled(Radio)`
    && {
        input {
            width: 24px;
            height: 24px;
        }
    }
`;
